import styled from 'styled-components/macro';


// Styled components
const Wrapper = styled.div`
	min-height: 0.01%;
	overflow-x: auto;
	
	@media screen and (max-width: 47.9375rem) {
		max-width: 100%;
		margin-bottom: 0.9375rem;
		overflow-y: hidden;
		-ms-overflow-style: -ms-autohiding-scrollbar;
		
		table {
			margin-bottom: 0;
		}
		
		table thead tr th,
		table tbody tr th,
		table tfoot tr th,
		table thead tr td,
		table tbody tr td,
		table tfoot tr td {
			white-space: nowrap;
		}
	}
`;

const Container = styled.table`
	width: 100%;
	max-width: 100%;
	margin-bottom: 0;
	background-color: transparent;
	border-spacing: 0;
	border-collapse: collapse;
	
	thead > tr > th,
	tbody > tr > th,
	tfoot > tr > th,
	thead > tr > td,
	tbody > tr > td,
	tfoot > tr > td {
		padding: 0.5rem;
		line-height: 1.42857143;
		vertical-align: middle;
		border-top: 0.0625rem solid #ddd;
		text-align: left;
		
		&.allow-wrapping {
			overflow-wrap: break-word;
			width: auto;
			max-width: 75vw;
			white-space: normal;
		}
	}
	
	thead > tr > th {
		vertical-align: bottom;
		border-bottom: 0.125rem solid #ddd;
		white-space: nowrap;
	}
	
	caption + thead > tr:first-child > th,
	colgroup + thead > tr:first-child > th,
	thead:first-child > tr:first-child > th,
	caption + thead > tr:first-child > td,
	colgroup + thead > tr:first-child > td,
	thead:first-child > tr:first-child > td {
		border-top: 0;
	}
	
	tbody > tr:nth-of-type(even) {
		background-color: #f9f9f9;
	}
	
	&& a {
		color: inherit;
	}
`;

const Table: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<Wrapper>
			<Container>{children}</Container>
		</Wrapper>
	);
};

export default Table;
